import script from "./AllWebinars.vue?vue&type=script&setup=true&lang=js"
export * from "./AllWebinars.vue?vue&type=script&setup=true&lang=js"

import "./AllWebinars.vue?vue&type=style&index=0&id=744eb40f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-744eb40f"]])

export default __exports__